package ai.jessie.web.pages.organisations

import ai.jessie.web.documents.DocumentFilter
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

// UC-017 A3, TC-017 step 8 and UC-020 steps 1-12 / TC-020: one opened document beside the list of
// the routed state.
@Page("{organisationId}/documents/{documentId}")
@Composable
fun organisationDocumentPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    val documentId = ctx.route.dynamicParams["documentId"].orEmpty()
    val filter = DocumentFilter.of(ctx.route.params["status"])
    if (!validOrganisationId(organisationId)) {
        documentProblemFrame(organisationId, organisationRequiredProblem())
    } else
        key(organisationId, documentId, filter) {
            documentsContent(organisationId, documentId, filter)
        }
}
